import { jsx } from "react/jsx-runtime";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { validateTidalLicense } from "../../base/index.js";
function AccountBalance(props) {
  return /* @__PURE__ */ jsx(
    AccountBalanceIcon,
    {
      "data-testid": "AccountBalance",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "AccountBalance",
      "data-tidal-icon-meta": "money,invoices,payments"
    }
  );
}
AccountBalance.tidalIconMeta = {
  categories: "money,invoices,payments",
  name: "AccountBalance"
};
validateTidalLicense();
export {
  AccountBalance
};
//# sourceMappingURL=AccountBalance.js.map
